import { css } from '@emotion/core'
import { colors } from 'styles/variables'

export const playedText = css`
  color: ${colors.greens.green6};
`
